<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" label-width="150px" v-loading="loading">
        <div class="row-title">油罐基础信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygCode" label="油罐名称：">
              {{ formData.ygCode || "-" }}
            </el-form-item></el-col>
          <el-col :span="12">
            <el-form-item prop="ygRegion" label="所属库区：">
              {{ getRegion(formData.ygRegion) || "-" }}
            </el-form-item></el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item prop="ygLevel" label="当前液位(米)：">
              {{ formData.ygLevel || "-" }}(米)
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item prop="ygTemperature" label="当前温度(℃)：">
              {{ formData.ygTemperature || "-" }}(℃)
            </el-form-item></el-col
          >
        </el-row> -->
        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygTypeName" label="储油类型：">
              {{ formData.ygTypeName || "-" }}
            </el-form-item></el-col>
          <el-col :span="12">
            <el-form-item prop="ygAllWeight" label="总容量(吨)：">
              {{ formData.ygAllWeight || "-" }}(吨)
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygWeight" label="当前存油量(吨)：">
              {{ formData.ygWeight || "-" }}(吨)
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row>
          <el-col :span="12">
            <el-form-item prop="ygHeight" label="最大高度：">
              {{ formData.ygHeight || "-" }}
            </el-form-item></el-col>
          <el-col :span="12">
            <el-form-item prop="ygTime" label="更新时间：">
              {{ formData.ygTime || "-" }}
            </el-form-item></el-col>
        </el-row> -->

        <div class="row-title">客户信息</div>
        <el-table size="mini" stripe border v-loading="loading" :data="tableData">
          <el-table-column show-overflow-tooltip min-width="100" label="客户名称" prop="userName"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" label="品种规格" prop="specName"></el-table-column>
          <!-- <el-table-column show-overflow-tooltip min-width="140" label="关联油罐" prop="ygCode"></el-table-column> -->
          <el-table-column show-overflow-tooltip min-width="120" label="存油数量" prop="quantity"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" label="创建时间" prop="ctime"></el-table-column>
        </el-table>
        <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
          @current-change="loadData">
        </el-pagination>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>

export default {
  name: 'OiltankManageDetail',
  data() {
    return {
      formData: {},
      dicList: [],
      loading: false,
      page: 1,
      total: 0,
      tableData: []
    }
  },
  created() {
    if (this.id) {
      this.loadData()
      this.loadCustomData()
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  methods: {
    getRegion(type) {
      const obj = {
        1: '一库区',
        2: '二库区',
        3: '三库区',
        4: '四库区',
        5: '五库区'
      }
      return obj[type] || '-'
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByYgId, {
        params: { ygId: this.id }
      }).then(res => {
        this.formData = res || {}
      }).finally(() => {
        this.loading = false
      })
    },
    loadCustomData () {
      this.loading = true
      this.$axios.get(this.$apis.customerOilStorage.selectYgnCustStorageByPage, {
        params: {
          ygId: this.id,
          page: this.page
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'ygType' }
      }).then(res => {
        this.dicList = res.ygType || []
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.form {
  margin-top: 30px;
  width: 450px;
}

.el-select {
  width: 100%;
}

.el-cascader {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}

.row-title {
  font-size: 14px;
  position: relative;
  padding-left: 14px;
  margin-bottom: 20px;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    height: 14px;
    width: 3px;
    background-color: #36f;
    border-radius: 2px;
    transform: translateY(-50%);
  }
}
</style>
